import { Context } from "../../index";
import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Form } from "react-bootstrap";

const GROUPED_ASS_TYPES = [
    { ids: [10, 14], label: "Paper Book BuyOut" },
    { ids: [11, 15], label: "Paper Book Search&BuyOut" },
    { ids: [18, 20], label: "Paper Book Verified Purchase" },
    { ids: [12, 16], label: "Paper Book Verified Purchase + Img" },
    { ids: [13, 17], label: "Paper Book Verified Purchase + Video" },
    { ids: [19, 21], label: "Paper Book VP Search&Buy" },
    { ids: [28, 29, 30, 31], label: "Make Helpful" },
];

const HIDDEN_ASS_TYPE_IDS = new Set([22, 23, 24, 25, 26, 27]);
const BOOK_LIBRARY_ASS_TYPE_IDS = new Set(
    Array.from({ length: 21 }, (_, index) => index + 1).concat([28, 29, 30, 31, 32])
);
const groupByAssTypeId = GROUPED_ASS_TYPES.reduce((acc, group) => {
    group.ids.forEach((id) => acc.set(id, group));
    return acc;
}, new Map());

const buildAssTypeOptions = (asstypes = []) => {
    const visibleTypes = asstypes
        .filter((type) => BOOK_LIBRARY_ASS_TYPE_IDS.has(type.id) && !HIDDEN_ASS_TYPE_IDS.has(type.id));
    const visibleTypeIds = new Set(visibleTypes.map((type) => type.id));
    const renderedGroups = new Set();

    return visibleTypes.reduce((options, type) => {
        const group = groupByAssTypeId.get(type.id);

        if (!group) {
            options.push({
                ...type,
                filterValue: String(type.id),
                filterLabel: type.ass_type_name,
            });
            return options;
        }

        const groupKey = group.ids.join(",");
        if (renderedGroups.has(groupKey)) {
            return options;
        }

        const ids = group.ids.filter((id) => visibleTypeIds.has(id));
        if (!ids.length) {
            return options;
        }

        renderedGroups.add(groupKey);
        options.push({
            ...type,
            id: ids.join(","),
            assTypeIds: ids,
            ass_type_name: group.label,
            filterValue: ids.join(","),
            filterLabel: group.label,
        });

        return options;
    }, []);
};

const TypeAssFiltrG = observer(() => {
    const { book } = useContext(Context);
    const assTypeOptions = buildAssTypeOptions(book.asstypes);

    const handleAssTypeChange = (event) => {
        const selectedValue = event.target.value;
        const selectedType = assTypeOptions.find((type) => type.filterValue === selectedValue) || {};
        book.setSelectedAssType(selectedType);
    };

    return (
        <div className="mb-0 border-success">
            <Form.Select
                id="assTypeSelect"
                value={book.selectedAssType?.id || ""}
                onChange={handleAssTypeChange}
                style={{ width: "120px" }}
                className="form-select-sm border border-success text-success"
            >
                <option value="">Type Filter...</option>
                {assTypeOptions.map((type) => (
                    <option key={type.filterValue} value={type.filterValue}>
                        {type.filterLabel + "\u00A0"}
                    </option>
                ))}
            </Form.Select>
        </div>
    );
});

export default TypeAssFiltrG;
